
// Module: WF / CC / DD
export const ClientType = {
    ModuleId: {
        Workflow: 1,
        ContactCenter: 23,
        DocDistro: 5,
    },
// DropdownCategoryType Enum
    DropdownCategoryType : {
        Contact_Role: 1,
        Opposing_Attorney: 3,
        Legal_Action_Type: 4,
        Service_Result_Type: 5,
        Judge: 6,
        Court: 7,
        Court_Hearing_Type: 8,
        Court_Hearing_Result: 9,
        Legal_Queue_Category: 10,
        Legal_Completed_Category: 13,
        Case_Function: 14,
        Complaint_Type: 16,
        Final_Resolution: 17,
        Modification_Result: 18,
        Requestor_Role: 19,
        NewWorkItem: 20, //Add in G2
        NextWorkItem: 21, //Work in G2
        Source_Of_Information: 22,
        NCP_Level_Of_Cooperation: 23,
        NCP_Relationship_With_CP: 24,
        NCP_How_Often_Sees_Child: 25,
        NCP_Education_Level: 26,
        NCP_Most_Common_Job: 27,
        NCP_Current_Ability_To_Pay: 28,
        NCP_Current_Ability_To_Work: 29,
        Payment_History: 30,
        Reason_For_NonPay: 31,
        Import_Exception: 34,
        Scan_Format: 35,
        Contact_Search_Role: 36,
        Contact_Center_Email_Recipient_Flag: 37,
        WalkIn: 38,
        Contact_Center_2: 39,
        Work_Workflows: 43,
        WorkflowMapType: 44,
        CP_NCP_NDI_IND: 45,
        Workflows_Complaint_Source: 46,
        Workflows_Complaint_Type: 47,
        Category_Sub_Category_Filter: 48,
        Legal_Service_Type: 49,
        Legal_Service_Result: 50,
        Legal_Requestor: 51,
        Legal_Summary_Views: 52,
        MultipleWorkflowNotificationFlag: 53,
        Case_View: 54,
        Action_Taken_Details: 55
    },

    // DropDownType Enum
    DropDownType : {
        Contact_Role__CP: 1,
        Contact_Role__NCP: 2,
        Contact_Role__Other: 3,
        Contact_Role__Attorney: 4,
        Contact_Role__Employer: 5,
        Contact_Role__State: 6,
        Contact_Role__Court: 7,
        Service_Result_Type__Cancelled: 19,
        Court_Hearing_Result__Error: 31,
        Court_Hearing_Result__Cancelled: 32,
        Service_Result_Type__Served: 100,
        Service_Result_Type__Failed: 101,
        Court_Hearing_Type__Hearing: 102,
        Court_Hearing_Result__Continued: 103,
        Court_Hearing_Result__Final_Order: 104,
        Court_Hearing_Result__Sentenced: 105,
        Legal_Queue_Category__Legal_View: 106,
        Legal_Queue_Category__Workflow_View: 107,
        Legal_Completed_Category__Workflow_View: 113,
        Legal_Completed_Category__QA_View: 114,
        Legal_Completed_Category__Variance_View: 115,
        Case_Function__Locate: 116,
        Complaint_Type__OCSE: 117,
        Complaint_Type__Governor: 118,
        Complaint_Type__CSS_Admin: 119,
        Modification_Result__Denied_No_Material_Change: 120,
        Requestor_Role__CP: 121,
        Requestor_Role__NCP: 122,
        Requestor_Role__State_Review: 123,
        Modification_Result__Denied_Other: 124,
        Modification_Result__Dismissed_No_Service: 125,
        Modification_Result__Dismissed_Other: 126,
        Modification_Result__Order_Entered: 127,
        Final_Resolution__Final_Call_To_Complainant: 128,
        Final_Resolution__Resolved_Previously: 129,
        Final_Resolution__Error: 130,
        Complaint_Type__Call_Center: 135,
        Complaint_Type__NCP: 136,
        Complaint_Type__CP: 137,
        Complaint_Type__Other: 138,
        Add__All_Open_Workflows: 139,
        Add__All_Open_And_Closed_Workflows: 144,
        Work__This_Workflow_Only: 145,
        Work__All_Open_Workflows: 146,
        Work__All_Open_And_Closed_Workflows: 147,
        Case_View__All_Open_Workflows: 374,
        Case_View__All_Open_And_Closed_Workflows: 375,
        Action_Taken__This_Workflow_Only: 376,
        Action_Taken__All_Open_Workflows: 377,
        Action_Taken__All_Open_And_Closed_Workflows: 378,
        Source_Of_Information__CP: 150,
        Source_Of_Information__NCP: 151,
        Source_Of_Information__Other: 152,
        NCP_Level_Of_Cooperation__Very_Good: 153,
        NCP_Level_Of_Cooperation__Good: 154,
        NCP_Level_Of_Cooperation__Poor: 155,
        NCP_Level_Of_Cooperation__Resistant: 156,
        NCP_Relationship_With_CP__Very_Good: 157,
        NCP_Relationship_With_CP__Good: 158,
        NCP_Relationship_With_CP__Poor: 159,
        NCP_How_Often_Sees_Child__Weekly: 160,
        NCP_How_Often_Sees_Child__Monthly: 161,
        NCP_How_Often_Sees_Child__Once_Every_Few_Months: 162,
        NCP_How_Often_Sees_Child__Once_A_Year: 163,
        NCP_How_Often_Sees_Child__Never: 164,
        NCP_Education_Level__No_High_School_Degree: 165,
        NCP_Education_Level__High_School_Degree: 166,
        NCP_Education_Level__Some_College: 167,
        NCP_Education_Level__College_Degree: 168,
        NCP_Education_Level__Advanced_Degree: 169,
        NCP_Most_Common_Job__Accounting: 170,
        NCP_Most_Common_Job__Admin_And_Clerical: 171,
        NCP_Most_Common_Job__Automotive: 172,
        NCP_Most_Common_Job__Banking: 173,
        NCP_Most_Common_Job__Broadcast_Journalism: 174,
        NCP_Most_Common_Job__Construction: 175,
        NCP_Most_Common_Job__Consultant: 176,
        NCP_Most_Common_Job__Customer_Service: 177,
        NCP_Most_Common_Job__Design: 178,
        NCP_Most_Common_Job__Distribution_Shipping: 179,
        NCP_Most_Common_Job__Education_Teaching: 180,
        NCP_Most_Common_Job__Engineering: 181,
        NCP_Most_Common_Job__Entry_Level_New_Grad: 182,
        NCP_Most_Common_Job__Executive: 183,
        NCP_Most_Common_Job__Facilities: 184,
        NCP_Most_Common_Job__Finance: 185,
        NCP_Most_Common_Job__Franchise: 186,
        NCP_Most_Common_Job__General_Business: 187,
        NCP_Most_Common_Job__General_Labor: 188,
        NCP_Most_Common_Job__Government: 189,
        NCP_Most_Common_Job__Grocery: 190,
        NCP_Most_Common_Job__Health_Care: 191,
        NCP_Most_Common_Job__Hotel_Hospitality: 192,
        NCP_Most_Common_Job__Human_Resources: 193,
        NCP_Most_Common_Job__Information_Technology: 194,
        NCP_Most_Common_Job__Maintenance_Repair_Installation: 195,
        NCP_Most_Common_Job__Insurance: 196,
        NCP_Most_Common_Job__Legal: 197,
        NCP_Most_Common_Job__Management: 198,
        NCP_Most_Common_Job__Manufacturing: 199,
        NCP_Most_Common_Job__Marketing: 200,
        NCP_Most_Common_Job__Nurse: 201,
        NCP_Most_Common_Job__Other: 202,
        NCP_Most_Common_Job__Pharmaceutical: 203,
        NCP_Most_Common_Job__Professional_Services: 204,
        NCP_Most_Common_Job__Real_Estate: 205,
        NCP_Most_Common_Job__Research: 206,
        NCP_Most_Common_Job__Restaurant_Food_Service: 207,
        NCP_Most_Common_Job__Retail: 208,
        NCP_Most_Common_Job__Sales: 209,
        NCP_Most_Common_Job__Science: 210,
        NCP_Most_Common_Job__Skilled_Labor_Trades: 211,
        NCP_Most_Common_Job__Telecommunications: 212,
        NCP_Most_Common_Job__Transportation: 213,
        NCP_Most_Common_Job__Warehouse: 214,
        NCP_Current_Ability_To_Pay__All: 215,
        NCP_Current_Ability_To_Pay__Part: 216,
        NCP_Current_Ability_To_Pay__None: 217,
        NCP_Current_Ability_To_Work__Able_And_Employed: 218,
        NCP_Current_Ability_To_Work__Able_And_Unemployed: 219,
        NCP_Current_Ability_To_Work__Partially_Disabled_And_Employed: 220,
        NCP_Current_Ability_To_Work__Partially_Disabled_And_Unemployed: 221,
        NCP_Current_Ability_To_Work__Disabled_And_Unemployed: 222,
        NCP_Current_Ability_To_Work__Completely_Disabled: 223,
        Payment_History__Consistent_Full_Payments: 224,
        Payment_History__Consistent_Partial_Payments: 225,
        Payment_History__Inconsistent_Full_Payments: 226,
        Payment_History__Inconsistent_Partial_Payments: 227,
        Payment_History__No_Payments: 228,
        Reason_For_NonPay__NCP_Lives_Within_50_Miles_Of_Office: 229,
        Reason_For_NonPay__NCP_Has_Substance_Abuse_History: 230,
        Reason_For_NonPay__NCP_Is_Incarcerated: 231,
        Reason_For_NonPay__NCP_Is_On_Parole_Or_Probation: 232,
        Reason_For_NonPay__NCP_Has_Multiple_Child_Support_Cases: 233,
        Reason_For_NonPay__NCP_Is_Self_Employed: 234,
        Reason_For_NonPay__NCP_Is_Disabled_Or_Claims_To_Be_Disabled: 235,
        Reason_For_NonPay__NCP_Is_A_Fulltime_Student: 236,
        Reason_For_NonPay__NCP_Isclaimed_Dom_Viol_Or_Child_Abuse_Perp: 237,
        Reason_For_NonPay__NCP_Is_Homeless: 238,
        Reason_For_NonPay__NCPs_Lifestyle_Is_Subsidized_By_Another: 239,
        Reason_For_NonPay__NCP_Is_In_The_Military_Or_Federal_Civil_Service: 240,
        Reason_For_NonPay__NCP_Has_An_Attorney: 241,
        Reason_For_NonPay__Children_Are_In_Foster_Care_Or_Kinship_Care: 242,
        Reason_For_NonPay__NCPs_And_CPs_Length_Of_Relationship: 243,
        Import_Exception__Invalid_Case_Number: 244,
        Import_Exception__Invalid_Step_Name: 245,
        Import_Exception__Invalid_Workflow_Map_Input_Text: 246,
        Scan_Format__One_Page_Single_Sided: 247,
        Scan_Format__Multipage_Duplex: 248,
        Scan_Format__Multipage_Duplex_Legal: 249,
        Contact_Role__Recipient: 250,
        Contact_Role__Mandated_Reporter: 251,
        Contact_Search_Role__CP: 252,
        Contact_Search_Role__NCP: 253,
        Contact_Search_Role__CP_And_NCP: 254,
        Contact_Role__UNKN_System_Unavailable: 255,
        Contact_Role__UNKN_Dropped_Call: 256,
        Contact_Center_Email_Recipient_Flag__No_Email: 257,
        Contact_Center_Email_Recipient_Flag__Email_Blank_TOCC: 258,
        Contact_Center_Email_Recipient_Flag__Email_Request_1: 259,
        Contact_Center_Email_Recipient_Flag__Email_Request_2: 260,
        Contact_Center_Email_Recipient_Flag__Email_Request_3: 261,
        Contact_Center_Email_Recipient_Flag__Email_Request_4: 262,
        WalkIn__Open_Workflows: 263,
        WalkIn__Open_And_Completed_Workflows: 264,
        Contact_Center_2__Open_Workflows: 265,
        Contact_Center_2__Open_And_Completed_Workflows: 266,
        Work_Workflows__Open_Workflows: 283,
        Work_Workflows__Completed_Workflows: 284,
        Work_Workflows__Open_And_Completed_Workflows: 285,
        WorkflowMapType__Add_Tab_Normal_Start: 286,
        WorkflowMapType__Add_Tab_Specialty_Start: 287,
        WorkflowMapType__Work_Tab_Specialty_Start: 288,
        WorkflowMapType__System_Refer_Dummy_Start: 289,
        CP_NCP_NDI_IND__WARNING_CP_NonDisclosure: 290,
        CP_NCP_NDI_IND__WARNING_NCP_NonDisclosure: 291,
        CP_NCP_NDI_IND__WARNING_NCP_And_CP_NonDisclosure: 292,
        WorkflowMapType__Exception_Dummy_Start: 293,
        Workflows_Complaint_Source__CP: 294,
        Workflows_Complaint_Source__NCP: 295,
        Workflows_Complaint_Source__State_Legislator: 296,
        Workflows_Complaint_Source__Federal_Legislator: 297,
        Workflows_Complaint_Source__Attorney: 298,
        Workflows_Complaint_Source__JudgeCourt: 299,
        Workflows_Complaint_Source__Governor_Office: 300,
        Workflows_Complaint_Source__Attorney_General: 301,
        Workflows_Complaint_Source__IVD_Office: 302,
        Workflows_Complaint_Source__IVD_Director: 303,
        Workflows_Complaint_Source__Other_Party: 304,
        Workflows_Complaint_Source__Other_State: 305,
        Workflows_Complaint_Type__Failure_To_Return_Call: 306,
        Workflows_Complaint_Type__Unhappy_Not_Receiving_Support: 307,
        Workflows_Complaint_Type__Court_Hearing: 308,
        Workflows_Complaint_Type__Case_Worker_Conduct: 309,
        Workflows_Complaint_Type__Attorney_Conduct: 310,
        Workflows_Complaint_Type__Other: 311,
        WorkflowMapType__AA_WF_Parameter_Map_Type: 312,
        Category_Sub_Category_Filter__Contact_Center_Only: 313,
        Category_Sub_Category_Filter__WalkIn_Only: 314,
        Category_Sub_Category_Filter__Contact_Center_And_WalkIn: 315,
        Category_Sub_Category_Filter__Neither_Contact_Center_Nor_WalkIn: 316,
        Legal_Service_Type__1st_Class_Mail: 317,
        Legal_Service_Type__Alternate: 318,
        Legal_Service_Type__Personal: 319,
        Legal_Service_Type__Voluntary_Acceptance: 320,
        Legal_Service_Result__Failed: 321,
        Legal_Service_Result__Successful: 322,
        Legal_Requestor__Attorney: 323,
        Legal_Requestor__Attorney_General: 324,
        Legal_Requestor__CP: 325,
        Legal_Requestor__Federal_Legislator: 326,
        Legal_Requestor__Governor_Office: 327,
        Legal_Requestor__IVD_Director: 328,
        Legal_Requestor__IVD_OfficePolicy: 329,
        Legal_Requestor__JudgeCourt: 330,
        Legal_Requestor__NCP: 331,
        Legal_Requestor__State_Legislator: 332,
        Legal_Requestor__Other_Party: 333,
        Legal_Requestor__Other_State: 334,
        Legal_Requestor__State: 335,
        Legal_Summary_Views__Hearings: 336,
        Legal_Summary_Views__Legal_Status_Reviews: 337,
        Legal_Summary_Views__Services_Of_Process: 338,
        Legal_Action_Type__PaternityFoster_Care: 339,
        Legal_Action_Type__SupportFoster_Care: 342,
        Legal_Action_Type__Motion_To_Compel: 351,
        Court_Hearing_Type__Pretrial_Conference: 352,
        Court_Hearing_Type__Settlement_Conference: 353,
        Court_Hearing_Type__Status_Docket: 354,
        Court_Hearing_Type__Trial: 355,
        Court_Hearing_Result__Temporary_Order: 356,
        Legal_Service_Type__Certified_Mail: 357,
        Legal_Action_Type__Income_Withholding: 358,
        Legal_Action_Type__Motion_To_Modify_IWO: 359,
        Legal_Action_Type__Stipulated_Agreement: 360,
        Legal_Action_Type__Appeals: 361,
        WorkflowMapType__Add_Tab_Others_Start: 362,
        MultipleWorkflowNotificationFlag__No_Restriction: 367,
        MultipleWorkflowNotificationFlag__Pop_Warning_To_User_With_Choice_To_Continue: 368,
        MultipleWorkflowNotificationFlag__Pop_Warning_To_User_And_Block: 369,
        Contact_Center_Email_Recipient_Flag__Emailed_ResolutionDM_Callback_Request: 371,
        Contact_Center_Email_Recipient_Flag__Emailed_Resolution2nd_Issue_DM_Callback: 372,
        Contact_Center_Email_Recipient_Flag__Emailed_ResolutionMissing_Application: 373,
    },
    ActivityType: {
        Contact_Activity:14,
    },
    SettingsDetail: {
        
        UI_Miscellaneous__District_Field_Show_Enable : 126,
        UI_Miscellaneous__County_Field_Show_Enable: 127,
        UI_Miscellaneous__Case_Type_Field_Show_Enable : 168,
        UI_Miscellaneous__Batch_Document_Stale_Lock_Timeout: 332,
        UI_Miscellaneous__Success_Notification_TIMER: 636,
        Document_Related__Export_Doc_Limit: 449,
        Document_Related__JScape_Server_Host: 517,
        Document_Related__JScape_Server_Login_URI: 513,
        UI_Data_Validation__Email_Regex_Pattern: 587,
        UI_Miscellaneous__Index_Soft_lock_Timer: 637,
        UI_Miscellaneous__FVI_Possibility_Range: 586,
        Workflow_Parameters__Confidential_Case_Criteria: 275,
        UI_Miscellaneous__Inactivity_Notification_Minutes: 647,
        UI_Miscellaneous__Error_Notification_Timer: 648,
        DMS_Scanning__Copy_Link_Temp_Path: 344,
        Code_Switching__Check_Mainframe_Connectivity_On_Search: 652,
        Import_Related__Document_Import_Archive_Path: 405,
        Import_Related__MDHS_Import_SweepProcessID: 407,
        UI_Miscellaneous__Include_UNKN_ContactRoles_For_With_Case: 625,
        UI_Miscellaneous__CatSubCatResult_Display_Order_Sort: 183,
        WalkIn_Related__WalkIn_Worktime_Capture_Workflow_Auto_Start_Enable: 373,
        Workflow_Parameters__Walk_In_Workflow_Map_Indv: 372,
        Workflow_Parameters__Walk_In_Workflow_Map_All:371,
        Workflow_Parameters__Workflow_Stale_Lock_Timeout_Min: 84,
        UI_Miscellaneous__Doc_Group_Exclusion_For_Workflow_Reindex: 652
    },
    NoteTemplate: {
        Customer_Service_Mainframe_Narrative: 10,
    },
    MessageContent: {
        U_UI7047_Successful_Document_Save: 496,
        V_DV3513_Case_Numbers_Must_Be_Formatted_As_Example: 225,
        N_UI3544_Export_Documents: 429,
        V_DV3537_CONFIDENTIAL_CASE_DATA: 454,
        V_DV3538_FVI_And_CONFIDENTIALCASE_DATA: 455,
        V_DV4031_Case_Marked_As_Confidential: 367,
        E_MF7049_Lost_Connection_To_State_System: 498,
        N_UI7055_Inactive_User: 504,
        N_UI3542_Document_Export_Limit: 427,
        E_UI7053_Case_Id_not_Found: 502,
        E_UI7056_Scrapper_Connection_Status: 505,
        N_UI7057_Document_Path_Copied: 506,
        N_UI4024_Confidential_Case_Warning: 509,
        N_UI7058_ENTER_A_FUNCTION_Error_Occured: 510,
        U_UI7037_Duplicate_Action: 451,
        V_MF4033_Confidential_Case_Message_Part_One:377,
        V_MF4034_Confidential_Case_Message_Part_Two: 378,
        V_DV7059_Case_Marked_As_Confidential: 511,
        N_UI7028_AutoEnd_Workflows: 415,
        N_UI7060_Confidential_Case_Permission_Warning: 512,
    },
    DataMapCategoryType: {
        Case_Type: 1,
        Status_Type:2,
        Family_Violence : 3,
        Confidential_Case : 22,
        FVI_And_Confidential_Case: 24,
    },
    DataMapType: {
        Confidential_Case : 36,
        FVI_And_Confidential_Case: 127,
        Closed: 5,
    },

    ErrorType: {
        MainframeDisconnected: 'MainframeSessionDisconnected',
        ScraperDisconnected: 'ScraperDisconnected',
        MainframeSessionError: 'mainframesessionerror'
    },
    DocExportMethodType: {
        JScape_Export : 1,
        Print_Document : 2,
        Save_Document : 3,
        Copy_Link : 4,
    },
    ActiveStatus: {
        Obsolete : 3,
    },
    ContactRole: {
        CP : 1,
        NCP : 2,
        Other : 3,
        Attorney : 4,
        Employer : 5,
        State : 6,
        Court : 7,
        Recipient : 8,
        Mandated_Reporter : 9,
        UNKN_System_Unavailable : 10,
        UNKN_Dropped_Call : 11,
        UNKN_Callback_Incomplete : 12,
        Agency : 257,
        Vendor : 260,
        Authorized_Rep : 261,
        Applicant : 262,
    },

    WorkflowCategoryType:{
        PLACEHOLDER : 0,
        Documents : 1,
        Complaints : 2,
        Escalations : 3,
        Legal : 4,
        NCP_Assessment : 5,
        Modification_Review : 6,
        WalkIn : 7,
        Follow_Ups : 8,
        CallChats : 9,
    }
}
